import React from 'react';

/**
 * Shared empty/loading/error placeholder for every Market section.
 * Never let a chart or table render a blank shell — always show a message.
 */
export const MarketEmptyState = ({ icon = '📊', title, message, tone = 'default' }) => (
  <div className={`mk-empty mk-empty--${tone}`}>
    <span className="mk-empty-icon" aria-hidden="true">{icon}</span>
    {title && <div className="mk-empty-title">{title}</div>}
    {message && <div className="mk-empty-message">{message}</div>}
  </div>
);

export const MarketSkeletonBlock = ({ height = 220 }) => (
  <div className="mk-skeleton" style={{ height }} />
);

export default MarketEmptyState;
